import { render, staticRenderFns } from "./cash-allowance.vue?vue&type=template&id=71bbfada&"
import script from "./cash-allowance.vue?vue&type=script&lang=js&"
export * from "./cash-allowance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports